// angular
// 	.module("HeroPRO")
// 	.directive('hpRolesSelector', rolesSelector);

import _ from 'lodash';
import './rolesSelector.scss';

/* @ngInject */
export default function rolesSelector(AccountsFactory, UserData, HPRoles) {
    const rolesSelectorController = function () {
        const vm = this;

        vm.defaultRole = {
            DisplayName: 'Choose Account Permission',
            DisplayDescription: '',
            Name: 'DEFAULT',
            RoleId: -1,
        };

        vm.roles = [];
        vm.selectedRole = {};

        // CSLB variables
        vm.cslbShowCheckBox = false;
        vm.cslbCheckBoxValue = false;
        vm.cslbshowError = false;
        vm.cslbSelectedQualifier = null;
        vm.cslbQualifiers = null;

        _.delay(() => {
            init();
        });

        /*= =======================================
		 =            Public Functions            =
		 ======================================== */

        vm.roleClicked = function (role) {
            vm.selectedRole = role;
            vm.role = role;
            displayCSLBCheckBox(vm.role);
        };

        vm.cslbCheckBoxClicked = function () {
            cslbCheckBoxClicked();
        };

        vm.cslbQualifierClicked = function (qualifier) {
            cslbQualifierClicked(qualifier);
        };

        /* -----  End of Public Functions  ------*/

        /*= =======================================
		 =            Private Functions            =
		 ======================================== */
        function init() {
            //			console.log("HPRoleSelector Init");
            getUser();
            setInitialUserData();
            displayCSLBCheckBox(vm.role);
            if (vm.user.IsCSLBHolder === true) {
                cslbCheckBoxClicked();
            }
        }

        function getUser() {
            UserData.getUserData().then((response) => {
                vm.currentUser = response;
                getRoles();
            });
        }

        function getRoles() {
            AccountsFactory.getUserRoles().then((response) => {
                const roles = response.data.Data;
                buildRoleList(roles);
            });
        }

        function buildRoleList(roles) {
            // TODO: (ajt 2/25/2016) Modify to handle hierarchy sorting
            const roleList = _.sortBy(roles, 'DisplayOrder');
            let roleIndex = -1;
            _.each(roleList, (role, idx) => {
                if (role.Name === vm.currentUser.Roles[0]) {
                    roleIndex = idx;
                }
            });
            vm.roles = roleList.slice(roleIndex);
            if (vm.role === undefined || vm.role === null) {
                if (_.findWhere(vm.roles, { RoleId: -1 }) === undefined) {
                    vm.roles.unshift(vm.defaultRole);
                }
                vm.selectedRole = vm.roles[0];
            } else {
                vm.selectedRole = _.find(vm.roles, role => role.Name === vm.role.Name);
            }
        }

        function displayCSLBCheckBox(role) {
            // Show CSLB checkbox only for California and Company Admins
            if (role !== null && (vm.licenseNumber !== null && vm.licenseNumber !== undefined)) {
                if (role.Name === HPRoles.COPO_COMPANY_ADMIN.Name) {
                    vm.cslbShowCheckBox = true;
                } else {
                    // Clear all CSLB variables
                    vm.cslbShowCheckBox = false;
                    vm.cslbCheckBoxValue = false;
                    vm.cslbshowError = false;
                    vm.cslbSelectedQualifier = null;
                }
            }
        }

        function cslbCheckBoxClicked() {
            vm.cslbCheckBoxValue = !vm.cslbCheckBoxValue;

            if (vm.cslbCheckBoxValue === true) {
                const data = { LicenseNumber: vm.licenseNumber };
                if (vm.filterLastName === 'true') {
                    data.OfficerLastName = vm.user.LastName;
                }
                AccountsFactory.getCSLBLicenseHolders(data).then((response) => {
                    if (response.data.Data.Personel && response.data.Data.Personel.length > 0) {
                        vm.cslbQualifiers = response.data.Data.Personel;
                        _.forEach(vm.cslbQualifiers, (qualifier) => {
                            qualifier.MiddleInitial = qualifier.MiddleName.substring(0, 1);
                        });
                        vm.cslbShowError = false;
                        if (vm.filterLastName === 'true') {
                            const qualifier = _.find(vm.cslbQualifiers, (q) => {
                                let found = vm.user.FirstName === q.FirstName && vm.user.LastName === q.LastName && vm.user.TitleId === q.TitleId;
                                if (vm.user.MiddleInitial !== undefined && vm.user.MiddleInitial !== null && vm.user.MiddleInitial !== '') {
                                    found = found && vm.user.MiddleInitial === q.MiddleInitial;
                                }
                                if (vm.user.Suffix !== undefined && vm.user.Suffix !== null && vm.user.Suffix !== '') {
                                    found = found && vm.user.Suffix === q.Suffix;
                                }
                                return found;
                            });
                            cslbQualifierClicked(qualifier);
                        }
                    } else {
                        vm.cslbShowError = true;
                    }
                });
            } else {
                vm.cslbSelectedQualifier = null;
                resetUserData();
            }
        }

        function resetUserData() {
            vm.user.FirstName = vm.initialUserData.FirstName;
            vm.user.LastName = vm.initialUserData.LastName;
            vm.user.MiddleInitial = vm.initialUserData.MiddleInitial;
            vm.user.Suffix = vm.initialUserData.Suffix;
            vm.user.TitleId = vm.initialUserData.TitleId;
            vm.user.licenseHolderSelected = false;
        }

        function setInitialUserData() {
            vm.initialUserData = {
                FirstName: vm.user.FirstName,
                LastName: vm.user.LastName,
                MiddleInitial: vm.user.MiddleInitial,
                Suffix: vm.user.Suffix,
                TitleId: vm.user.TitleId,
            };
        }

        function cslbQualifierClicked(qualifier) {
            if (qualifier !== undefined && qualifier !== null) {
                vm.cslbSelectedQualifier = qualifier;
                vm.user.FirstName = qualifier.FirstName;
                vm.user.LastName = qualifier.LastName;
                vm.user.MiddleInitial = qualifier.MiddleInitial;
                vm.user.Suffix = qualifier.Suffix;
                vm.user.TitleId = qualifier.TitleId;
                vm.user.licenseHolderSelected = true;
            }
        }
    };

    return {
        replace: true,
        restrict: 'E',
        scope: {
            user: '=',
            role: '=',
            submitted: '=',
            licenseNumber: '=',
            hideSelector: '@',
            filterLastName: '@',
            required: '=',
        },
        require: '^form',
        templateUrl: 'app/accounts/user/personalInformation/roles/rolesSelector.html',
        controller: rolesSelectorController,
        controllerAs: 'rolesSelector',
        bindToController: true,
    };
}




// WEBPACK FOOTER //
// ./src/app/accounts/user/personalInformation/roles/hpRolesSelector.js